import React from 'react';
import { SVGProps } from './type';

export const IconAccountActivity = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 1.999H5.001a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3V5a3 3 0 0 0 -3 -3m-15 3c0 -0.552 0.449 -1.001 1.001 -1.001h14c0.553 0 1.001 0.449 1.001 1.001v14a1.001 1.001 0 0 1 -1.001 1.001H5.001a1.001 1.001 0 0 1 -1.001 -1.001zm12.112 2.754a1.001 1.001 0 0 0 -1.911 -0.09L12.154 13.395 10.332 9.57a1.001 1.001 0 0 0 -1.77 -0.066L7.135 12H6a1.001 1.001 0 1 0 0 1.999h1.715c0.358 0 0.69 -0.192 0.867 -0.504l0.765 -1.34 2.035 4.274a1.001 1.001 0 0 0 1.845 -0.093l1.755 -4.911 0.335 1.32a1.005 1.005 0 0 0 0.969 0.754H18a1.001 1.001 0 0 0 0 -2.001h-0.938z"
        fill={fill}
      />
    </g>
  );
};
